import config from '@/config'

const parseAllowedDomains = (): string[] => (
  (config.TRUSTED_DEVICE_SETUP_REDIRECT_URI_ALLOWED_DOMAINS || '')
    .split(',')
    .map(domain => domain.trim())
    .filter(Boolean)
)

export const isAllowedRedirectUri = (uri: string): boolean => {

  try {

    const url = new URL(uri)

    const allowedDomains = parseAllowedDomains()

    const isAllowedHostname = url.hostname === window.location.hostname
      || allowedDomains.some(domain => (
        domain.startsWith('.')
          ? (url.hostname === domain.slice(1) || url.hostname.endsWith(domain))
          : url.hostname === domain
      ))

    if (!isAllowedHostname) {
      return false
    }

    return url.protocol === 'https:' || url.hostname === 'localhost'

  } catch {
    return false
  }

}
